import React from "react";
import { Button } from "@mui/material";

type Props = {
  handleClick: () => void;
};

const CancelButton = ({ handleClick }: Props) => (
  <Button
    variant={"text"}
    onClick={() => handleClick()}
    sx={{ color: "#BD4257" }}
  >
    Cancel
  </Button>
);

export default CancelButton;
